module.exports = __webpack_public_path__ + "img/send-message.f88e1e39.svg";